module.exports = __webpack_public_path__ + "static/media/test15_2.256c3021.png";